import styled from 'styled-components';

export const PricingBrief = styled.div`
    margin: 40px;
    text-align: center;

    .package-name {
        font-size: 16px;
        color: var(--color-primary-500);
    }

    .price {
        margin: 0 5px;
        font-size: 48px;
        font-weight: 500;
        color: var(--color-text-700);

        &-wrap {
            margin: 20px 0;
        }

        &-prefix,
        &-suffix {
            font-size: 16px;
            color: var(--color-text-500);
        }

        &-meta {
            display: inline-block;
            margin-bottom: 15px;
        }

        &-special {
            color: var(--color-primary-500);
        }

        &-strike {
            text-decoration: line-through;
        }
    }
`;

export const Column = styled.div`
    border-radius: 5px;
    border: 1px solid var(--color-border-500);

    &.featured {
        border: 2px solid var(--color-primary-500);

        .package-name {
            color: #fff;
            padding: 9.5px;
            font-weight: 500;
            text-align: center;
            background: var(--color-primary-500);
        }
    }
`;

export const PlanInfo = styled.div`
    display: flex;
    margin-bottom: 40px;
    align-items: center;

    .push-right {
        flex: 1;
        text-align: right;
    }

    span {
        margin-right: 20px;
    }
`;

export const UpdateModalBody = styled.div`
    p {
        &:first-child {
            margin-top: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const FeatureList = styled.ul`
    margin: 0;
    padding: 0;
    margin: 40px;
    list-style-type: none;

    li {
        margin-top: 15px;
        color: var(--color-text-300);

        svg {
            margin-right: 15px;
        }

        &:first-child {
            margin-top: 0;
        }

        &.active {
            color: var(--color-text-500);

            svg {
                color: var(--color-primary-500);
            }
        }
    }
`;
